var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"achievements--list__container"},[_c('div',{staticClass:"list xl:w-4/5 lg:w-11/12 mr-auto ml-auto"},_vm._l((_vm.getAchievements),function(value,id){return _c('achievement-each',{key:id,attrs:{"details":value}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }